import React, { useState } from 'react'
import {withRouter} from 'react-router-dom'
import useSWR, {mutate} from 'swr'
import {AppFetcher} from '../../fetch/application'
import {GlossaryFetcher} from "../../fetch/glossary"
import {ApplicationModel} from '../../models'
//State
import {useSelector, useDispatch} from 'react-redux'
import appSlice from '../../store/slices/aplications'
// Components
import {
    Button,
    Icon,
    Header,
    Input,
    Grid
} from 'semantic-ui-react'
import {AppDialog, AppDataContent, AppDataFlow, AppDataCreation} from './dialogs'
import {Message} from '../error'
import Loader from '../loader'
import styles from './styles.module.scss'
import SidebarPanel from "./SidebarPanel"

function List({ history, match }) {

    const dispatch = useDispatch()
    const {dialogVisible} = useSelector(state => state.applications)

    const handleDialogVisibility = () => {
        dialogVisible && setEditDialog(false)
        dispatch(appSlice.actions.setDialogVisibility(!dialogVisible))
    }

    /*const handleOpenApp = app => {
        dispatch(appSlice.actions.openApplication(app))
        history.push(`/applications/${app.id}`)
    }*/

    const [sidebarApp, setSidebarApp] = useState(null);
    const [sidebarVisible, setSidebarVisible] = useState(false);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogOpenFlow, setDialogOpenFlow] = useState(false);
    const [dialogOpenCreation, setDialogOpenCreation] = useState(false);
    const [shouldFetchDetail, setShouldFetchDetail] = useState(false)

    const toggleSidebar = app => {

        if(sidebarVisible && app.id === sidebarApp.id) {
            setSidebarVisible(false)
            setSidebarApp(null)
            //setShouldFetchDetail(true)
            //setAppId(null)
            //loadElements.current = false
            history.push(`/applications/`)
        }
        else {
            setShouldFetchDetail(true)
            setSidebarVisible(true)
            setSidebarApp(app)
            history.push(`/applications/${app.id}`)
            //setAppId(app.id)
            //loadElements.current = true
        }
    }

    const closeSidebar = () => {
        setSidebarVisible(false)
        history.push(`/applications/`)
    }

    const [editDialog, setEditDialog] = useState(false);
    const editSidebar = () => {
        //mutate(`/application/details/${sidebarApp.id}`)
        handleDialogVisibility(true);
        setEditDialog(true);
    }

    const [searchTerm, setSearchTerm] = useState("");
    history.listen(location => {
        setSearchTerm("");
    });
    let urlPart = "/application/list";
    if (searchTerm) {
        urlPart += "/filter/" + searchTerm
    }

    const handleSearch = (e, {value}) => {
        setSearchTerm(value)
    }

    const [content, setContent] = useState(null)
    const [dataFlow, setDataFlow] = useState(null);
    const toggleDialog = (e, isFlow, flow) => {
        if(dialogOpen || isFlow === undefined) {
            setDataFlow(null)
            setContent(null)
        }

        if(!dialogOpen) {
            if(isFlow) {
                e && e.id && setContent(e)
                flow && flow.id && setDataFlow(flow)
            }
            else {
                e && e.id && setContent(e)
            }
        }
        setDialogOpen(!dialogOpen)
    }

    const [flow, setFlow] = useState(null)
    const toggleDialogFlow = (e) => {
        !dialogOpenFlow && setFlow(e)
        dialogOpenFlow && setFlow(null)
        setDialogOpenFlow(!dialogOpenFlow)
    }

    const [creationContent, setCreationContent] = useState(null)
    const [creationData, setCreationData] = useState(null)
    const toggleDialogCreation = (content, data) => {
        !dialogOpenCreation && setCreationContent(content)
        !dialogOpenCreation && setCreationData(data)
        dialogOpen && setCreationContent(null)
        dialogOpen && setCreationData(null)
        setDialogOpenCreation(!dialogOpenCreation)
    }

    const { data: listComplete, errorComplete } = useSWR(`/application/list`, AppFetcher, {errorRetryCount: 2})

    const { data: list, error } = useSWR(`${urlPart}`, AppFetcher, {errorRetryCount: 2})

    const { data: appDetails, errorDetails } = useSWR((!shouldFetchDetail || !sidebarApp) ? null : `/application/details/${sidebarApp.id}`, GlossaryFetcher, { errorRetryCount: 2 });
    React.useEffect(() => {
        if(appDetails) {
            setShouldFetchDetail(false);
            setSidebarApp(appDetails.data)
        }
    }, [appDetails])
    const { data: appDet, errorDet } = useSWR((/*!shouldFetchDetail || */!match.params.id) ? null : `/application/details/${match.params.id}`, GlossaryFetcher, { errorRetryCount: 2 });
    React.useEffect(() => {
        if(appDet) {
            setShouldFetchDetail(false);
            setSidebarApp(appDet.data)
        }
    }, [appDet])
    if (match.params.id && !shouldFetchDetail && !sidebarApp) {
        setShouldFetchDetail(true)
        setSidebarVisible(true)
    }

    const [userDetail, setUserDetail] = useState(null)
    const {data: user, errorUser} = useSWR((!sidebarApp || !sidebarApp.lastAttestedBy) ? null : `/user/details/${sidebarApp.lastAttestedBy}`, AppFetcher, { errorRetryCount: 2 })
    React.useEffect(() => {
        if(user && user.data) {
            setUserDetail(user.data)
            setSidebarApp(value => {
                return {
                    ...value,
                    user: user.data
                }

            })
        }}, [user])

    const handleSave = data => {
        const tmpA = sidebarApp;
        setSidebarApp(null);
        //mutateDetails(`/application/details/${sidebarApp.id}`)
        //mutate(`/application/details/${sidebarApp.id}`)
        dialogOpenFlow && setDialogOpenFlow(!dialogOpenFlow)
        /*dialogOpenFlow && */setFlow(null)
        dialogOpenCreation && toggleDialogCreation()
        dialogOpen && toggleDialog()
        setSidebarApp(tmpA);
        setShouldFetchDetail(true);
    }

    const onSubmitApp = (id) => {
        //setSidebarApp(id.data);
        setShouldFetchDetail(true);
        mutate('/application/list')
        mutate(`/application/details/${match.params.id}`)
    }

    if (error) {

        const message = error.response
            ? error.response.data.statusMessage
            : 'Something went wrong'

        return (
            <div className={styles.content}>
                <Message negative header={message} />
            </div>
        )
    }

    const applications = list && list.data
        ? list.data.map( app => new ApplicationModel(app) )
        : []

    return (
        <div className={styles.content}>

            <Header size="huge">Applications</Header>

            <Button primary onClick={ handleDialogVisibility }>
                <Icon style={{marginRight: '15px !important'}} name="plus" />
                Create new
            </Button>

            <br /><br />

            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <Input
                            icon="search"
                            iconPosition="left"
                            placeholder="Search Applications"
                            onChange={handleSearch}
                        />
                    </Grid.Column>
                </Grid.Row>

                {!list && <Loader /> }

                { applications.map( app => (
                    <Grid.Row
                        className={styles.row}
                        key={`app-${app.id}`}
                        onClick={() =>  toggleSidebar(app)/*handleOpenApp({id: app.id, name: app.name})*/}
                    >
                        <Grid.Column width={8}>
                            <strong>{app.name}</strong>
                        </Grid.Column>
                        <Grid.Column width={8} textAlign="right" style={{textTransform: "capitalize"}}>
                            {app.type}
                        </Grid.Column>
                    </Grid.Row>
                ))}
                <br/>
            </Grid>

            {sidebarApp && listComplete && listComplete.data &&  <SidebarPanel
                visible={sidebarVisible}
                item={sidebarApp}
                close={closeSidebar}
                edit={editSidebar}
                handleDialogVisibility={toggleDialog}
                handleFlowVisibility={toggleDialogFlow}
                openDialogCreation={toggleDialogCreation}
                //openDialogFlowContent={toggleDialogFlowContent}
                apps={listComplete.data}
            />}

            <AppDialog
                title={"Add new application"}
                open={dialogVisible}
                item={(editDialog && sidebarApp) && sidebarApp}
                onClose={handleDialogVisibility}
                //onSubmit={() => onSubmitApp(sidebarApp.id)}
                onSubmit={onSubmitApp}
            />

            {sidebarApp && dialogOpen && <AppDataContent
                title={"Add new"}
                open={dialogOpen}
                onClose={toggleDialog}
                onSubmit={handleSave}
                id={sidebarApp && sidebarApp.id}
                flow={dataFlow ? dataFlow : null}
                item={content ? content : null}
            />}

            {sidebarApp && creationContent && <AppDataCreation
                title={"Add new Data Creation"}
                open={dialogOpenCreation}
                onClose={toggleDialogCreation}
                onSubmit={handleSave}
                id={sidebarApp && sidebarApp.id}
                content={creationContent}
                data={creationData ? creationData : null}
            />}

            {sidebarApp && <AppDataFlow
                id={sidebarApp && sidebarApp.id}
                open={dialogOpenFlow}
                onClose={toggleDialogFlow}
                onSubmit={handleSave}
                flow={flow ? flow : null}
            />}

        </div>
    )

}

export default withRouter(List)
